/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import {
  deleteWorkPlacesList,
  getWorkPlacesList,
} from "../../../apis/work-places";
import { getParams } from "../../../utils/params";
import Location from "./Location";
import useForm from "../../../hooks/useForm";
import systemAlert from "../../../utils/systemAlert";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

const AttendanceLocation = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [fields] = useState([
    { title: "사업장", key: "placeName" },
    { title: "장치타입", key: "type" },
    { title: "UUID", key: "beaconId" },
    { title: "MAC Address", key: "beaconMacAddress" },
    {
      title: "위치", key: "address", onValue: (value, field, data) => {
        return (data.latitude && data.longitude) ? `${data.latitude},${data.longitude}` : `등록된 위치가 없습니다.`
      }
    }
  ]);
  const [filters] = useState([
    {
      title: "필터 선택",
      type: "select",
      key: "searchType",
      options: {
        list: [
          { label: "사업장", value: "placeName" },
          /* { label: "주소", value: "address" }, */
        ],
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ])
  // 상세
  const [detailOpen, setDetailOpen] = useState(false);
  const [formMode, setFormMode] = useState("create");
  const [formData, setFormData] = useState({});
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'WORK_PLACE_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "WORK_PLACE_MANAGEMENT")
      }
    }
  }, [permissions])

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'placeName',
      searchText: '',
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);


  const submit = (params) => {
    setIsLoading(true);
    getWorkPlacesList(getParams(params))
      .then((res) => {
        if (!res) return;
        setTotal(res.data.total);
        setList(res.data.places);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };



  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (data) => {
          systemAlert('해당 출퇴근 장소를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  deleteWorkPlacesList(data.idx).then(() => {
                    submit(form);
                  });
                }
              }
            ]
          })
        },
      },
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setDetailOpen(true);
          setFormMode("modify");
          setFormData(data);
        },
      },
    ],
  };

  const headerButtons = [
    {
      label: "출퇴근 장소 추가",
      action: () => {
        setDetailOpen(true);
        setFormMode("create");
        setFormData({});
      },
    },
  ];

  const handleRowClick = (data, e) => {
    const tagName = e.target.tagName
    if (!(tagName === 'TR' || tagName === 'TD')) return
    setDetailOpen(true)
    setFormData(data)
    setFormMode('view')
  }

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader title={"출퇴근 장소 관리"} buttons={targetPermission.level > 1 ? headerButtons : []} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange} />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          selectedList={selectedList}
          setSelected={setSelectedList}
          rowBtn={targetPermission.level > 1 ? rowBtnConfig : {}}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
          onSelect={handleRowClick}
        />
        <Location
          list={formData}
          mode={formMode}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={() => submit(form)}
        />
      </>
    ));
};

export default AttendanceLocation;
